/**
 * State Manager — centralized state for dual-deck DJ console
 */

const defaultDeck = () => ({
  trackName: null,
  artist: null,
  bpm: 0,
  duration: 0,
  volume: 1.0,
  isPlaying: false,
  hotCues: [null, null, null, null],
  loopIn: null,
  loopOut: null,
  loopActive: false,
  isSynced: false,
  eqLow: 0,
  eqMid: 0,
  eqHigh: 0,
  filterValue: 0,   // -1 to +1: negative = lowpass, positive = highpass
  reverbWet: 0,
  killLow: false,
  killMid: false,
  killHigh: false,
})

export class StateManager {
  constructor() {
    this.decks = {
      A: defaultDeck(),
      B: defaultDeck(),
    }
    this.mixer = {
      crossfader: 0.5,
      masterVolume: 0.85,
      autoMixActive: false,
    }
    this._listeners = []
  }

  updateDeck(id, updates) {
    this.decks[id] = { ...this.decks[id], ...updates }
    this._notify()
  }

  updateMixer(updates) {
    this.mixer = { ...this.mixer, ...updates }
    this._notify()
  }

  subscribe(fn) {
    this._listeners.push(fn)
  }

  _notify() {
    const snapshot = { decks: this.decks, mixer: this.mixer }
    this._listeners.forEach(fn => fn(snapshot))
  }
}
